import React, { useCallback, useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  FaHeart,
  FaRetweet,
  FaCommentDots,
  FaShare,
  FaEllipsisH,
  FaUserPlus,
  FaUserCheck,
  FaEye,
} from 'react-icons/fa';
import clsx from 'clsx';
import { createUseStyles } from 'react-jss';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';

import Text from '../../../components/Text';
import Button from '../../../components/Button';
import { Twig, TwigButton } from '../../../types';
import { calculateDiscount } from '../../../lib/utils';
import LinkButton from '../../../components/LinkButton';
import BackgroundImage from '../../../components/BackgroundImage';
import IconButton from '../../../components/IconButton';
import AddToCartModal from '../../../components/AddToCartModal';
import {
  addTwigToTodo,
  deleteTodoByTwigID,
} from '../../../services/TwigService';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../config/store';
import { showLoginModal } from '../../../actions/ui';
import { unfollowUser, followUser } from '../../../services/ProfileService';
import { removeUserFollow, addUserFollow } from '../../../actions/auth';
import { reaction } from '../../../services/productService';
import { track } from '../../../services/mixpanelService';
import Loader from '../../../components/Loader';

export interface DetailsProps {
  twig: Twig;
}

const Details: React.FC<DetailsProps> = ({ twig }) => {
  const classes = useStyles();
  const isAuthenticated = useSelector<RootState, boolean>(
    (state) => state.auth.isAuthenticated,
  );
  const followerList = useSelector<RootState, number[]>(
    (state) => state.auth.usersFollow,
  );

  console.log(twig)
  const [isFollower, setIsFollower] = useState(false);
  const dispatch = useDispatch();
  const [isFavourite, setIsFavourite] = useState(twig.isFavourite);
  const [isFavouriting, setIsFavoriting] = useState(false);
  const [buyModalOpen, setBuyModalOpen] = useState(false);
  const [loading, setLoading] = useState<boolean>(true)
  const [button, setButton] = useState<TwigButton | null>(null);


  useEffect(() => {
    (async () => {
      twig.buttons.forEach(element => {
        if (element.status == "Active") {
          setButton(element);
        }
      });
      if (followerList.indexOf(+twig.user.id) != -1) {
        setIsFollower(true);
      }
      else {
        setIsFollower(false);

      }
      var x = await reaction({ "type": "View", "product_id": twig.product.id, "twig_id": twig.id })

    })()
  }, [followerList, twig])
  const handleUserFollow = useCallback(() => {
    (async () => {
      try {
        if (!isAuthenticated) {
          dispatch(showLoginModal());
          return
        }
        if (isFollower) {
          await unfollowUser(+twig.user.id);
          dispatch(removeUserFollow(+twig.user.id));
          track("un_follow")
        } else {
          await followUser(+twig.user.id);
          track("follow")
          dispatch(addUserFollow(+twig.user.id));
        }
      } catch (e) { }
    })();
  }, [isFollower, twig, isAuthenticated]);

  const handleToggleBuyModal = useCallback(() => {
    (async () => {
      setBuyModalOpen(!buyModalOpen);
      if (!buyModalOpen) {
        var x = await reaction({ "type": "Click", "product_id": twig.product.id, "twig_id": twig.id })
        track("buy_now")
        track("add_to_cart")
        track("begin_checkout")
      }
    })()
  }, [buyModalOpen]);

  const handleAddToFavourites = useCallback(() => {
    (async () => {
      setIsFavoriting(true);
      try {
        if (isFavourite) {
          twig.favorites--
          setIsFavourite(false);
          await deleteTodoByTwigID(twig.id);
        } else {
          setIsFavourite(true);
          twig.favorites++
          await addTwigToTodo(twig.id);
        }
      } catch (e) {
        if (!isFavourite) {
          twig.favorites--
          setIsFavourite(false);
        } else {
          twig.favorites++
          setIsFavourite(true);
        }
      }
      setIsFavoriting(false);
    })();
  }, [isFavourite, twig]);



  const goToLink = useCallback((link) => {
    (async () => {
      try {
        window.open(link, "_blank") //to open new page        
        var x = await reaction({ "type": "Click", "product_id": twig.product.id, "twig_id": twig.id })
        track("buy_now")
        track("add_to_cart")
        track("begin_checkout")
      } catch (error) {

      }
    })();

  }, []);


  const handleShare = useCallback(() => {
    try {
      // @ts-ignore
      if (typeof window.navigator.share === 'function') {
        // @ts-ignore
        window.navigator.share({
          text: twig.description,
          url: window.location.href,
        });
        track("share")
      }
    } catch (e) { }
  }, [twig]);

  const videoRef = useRef<HTMLVideoElement>();
  const handleVideoClick = useCallback(() => {
    if (!videoRef.current) return;
    const video = videoRef.current;
    const isVideoPlaying = !!(
      video.currentTime > 0 &&
      !video.paused &&
      !video.ended &&
      video.readyState > 2
    );
    if (isVideoPlaying) {
      video.pause();
    } else {
      video.play();
    }
  }, [videoRef]);


  const handleCanPlay = useCallback(() => {
    if (!videoRef.current) return;
    setLoading(false)
  }, [videoRef]);

  // const hasDiscount = twig.price !== twig.transformedPrice;
  // const discount = hasDiscount
  //   ? calculateDiscount(twig.price, twig.transformedPrice)
  //   : 0;

  const hasDiscount = twig.product && twig.product.originalPrice !== twig.product.discountedPrice && twig.product.discountedPrice != 0;
  const discount = hasDiscount
    ? calculateDiscount(twig.product.originalPrice, twig.product.discountedPrice)
    : 0;

  const currencyCode = twig.product.currency.currencyCode;
  return (
    <Container className="p-0" fluid>
      <Row>

        <AddToCartModal
          twig={twig}
          product={twig.product}
          show={buyModalOpen}
          onHide={handleToggleBuyModal}
          onClose={handleToggleBuyModal}
          centered
        />
        <Col xs={12} lg={6}>
          <div className={classes.thumbnailBox}>
            {twig.mediaType === 'IMAGE' || twig.mediaType === 'UNKNOWN' ? (
              <BackgroundImage src={twig.mediaUrl} height="100%" />
            ) : (
              <>
                <Loader className={classes.loader} loading={loading} size={30} />
                <div className={classes.videoBox}>
                  <video
                    // @ts-ignore
                    ref={videoRef}
                    className={classes.video}
                    onClick={handleVideoClick}
                    autoPlay
                    onCanPlay={() => handleCanPlay()}
                    controls={false}
                    poster={twig.mediaThumbUrl}
                  >
                    <source src={twig.mediaUrl} />
                  </video>
                </div>
              </>
            )}
          </div>
        </Col>
        <Col xs={12} lg={6}>
          <div className="p-3">
            <div className={clsx(classes.priceBox, 'pt-3', 'pb-3', classes.productDetailsBox)}>
              {twig.product.photo ? (

                <div
                  className={clsx(
                    classes.productDetailsSidebox,
                    classes.leftProductDetailsSidebox,
                  )}
                >

                  <BackgroundImage
                    src={twig.product.photo}
                    height="75px"
                    resizeMode="cover"
                    className={classes.productDetailsImage}
                  />
                </div>
              ) : null}
              <div className={clsx(classes.rightProductDetailsSidebox, 'pl-3')}>

                <Text
                  className={clsx(classes.priceText, classes.currentPrice)}
                  as="span"
                  uppercase
                  bold
                >
                  {hasDiscount ? twig.product.discountedPrice : twig.product.originalPrice ? twig.product.originalPrice : twig.price}{' '}
                  {currencyCode}
                </Text>
                {hasDiscount ? (
                  <>
                    <Text
                      className={clsx(classes.priceText, classes.oldPrice)}
                      as="span"
                      uppercase
                      bold
                      decoration="line-through"
                    >
                      {twig.product.originalPrice} {currencyCode}
                    </Text>
                    <Text
                      className={clsx(classes.priceText, classes.sale)}
                      as="span"
                      uppercase
                      bold={true}
                    >
                      {discount}%
                    </Text>
                  </>
                ) : null}
                <Text as="h1" fontSize="size2" bold>
                  <Link
                    className={classes.link}
                    to={`/${twig.product.uniqueName}`}
                  >
                    {twig.product.name}
                  </Link>
                </Text>
                <Text as="span" subText>
                  <Link
                    className={classes.link}
                    to={`/${twig.product.uniqueName}`}
                  >

                    {twig.business.name}
                  </Link>
                </Text>
              </div>
            </div>

            <div className={clsx(classes.actionsBox, 'mt-4')}>
              {button != null ?
                button.type == 'CALL' || button.type == 'EXPRESS_INTEREST' ? (
                  <LinkButton
                    key={button.id}
                    className={clsx(classes.actionBtn)}
                    color="primary"
                    size="large"
                    href={button.action}
                    target="_blank"
                    rounded
                  >
                    <Text color='white' as="span" bold capitalized>
                      {button.title}
                    </Text>
                  </LinkButton>
                ) :
                  button.type == 'OPEN_URL' ?
                    <Button
                      className={clsx('mr-2', classes.actionBtn)}
                      onClick={e => goToLink(button.action)}
                      color="primary"
                      rounded
                    >
                      <Text color='white' as="span" bold capitalized>
                        {button.title}
                      </Text>
                    </Button> :
                    <Button
                      className={clsx('mr-2', classes.actionBtn)}
                      onClick={handleToggleBuyModal}
                      color="primary"
                      rounded
                    >
                      <Text color='white' as="span" bold capitalized>
                        Buy
                      </Text>
                    </Button>
                :
                twig.product.is_verified ?
                  twig.product.affiliate == "EXTERNAL" || twig.product.affiliate == "INTERNAL" ?
                    <Button
                      className={clsx('mr-2', classes.actionBtn)}
                      onClick={e => goToLink(twig.product.affiliate == "EXTERNAL" ? twig.product.affiliate_link : twig.product.original_url)}
                      color="primary"
                      rounded
                    >
                      <Text color='white' as="span" bold capitalized>
                        Buy
                      </Text>
                    </Button>

                    :
                    <Button
                      className={clsx('mr-2', classes.actionBtn)}
                      onClick={handleToggleBuyModal}
                      color="primary"
                      rounded
                    >
                      <Text color='white' as="span" bold capitalized>
                        Buy
                      </Text>
                    </Button>

                  : null
              }
              {/* {twig.buttons
                ?.filter((btn) => btn.status === 'Active')
                .map((button) =>
                  button.type === 'OPEN_URL' ? (
                    <LinkButton
                      key={button.id}
                      className={clsx(classes.actionBtn)}
                      color="primary"
                      size="large"
                      href={button.action}
                      target="_blank"
                      rounded
                    >
                      <Text as="span" color="white" capitalized>
                        {button.title}
                      </Text>
                    </LinkButton>
                  ) : button.type === 'BUY' ? (
                    <Button
                      key={button.id}
                      className={clsx(classes.actionBtn)}
                      color="primary"
                      size="large"
                      onClick={handleToggleBuyModal}
                      rounded
                    >
                      <Text as="span" color="white" capitalized>
                        {button.title}
                      </Text>
                    </Button>
                  ) : (
                        <a
                          key={button.id}
                          className={clsx(classes.actionLink)}
                          href="https://twigbig.com/app"
                        >
                          <Text as="span" color="white" capitalized>
                            {button.title}
                          </Text>
                        </a>
                      ),
                )} */}
            </div>
            <div className={clsx(classes.descriptionBox, 'mt-5')}>
              <div className={clsx(classes.descriptionHeader)}>
                <div className={clsx(classes.avatarBox)}>
                  <Link
                    className={classes.link}
                    to={`/${twig.user.uniqueName}`}
                  >

                    <Image
                      className={clsx(classes.avatar)}
                      src={twig.user?.avatarUrl}
                      roundedCircle
                    />
                  </Link>
                  <div onClick={handleUserFollow} className={clsx(classes.followIconBox, isFollower ? classes.followIconBoxFollower : null)}>
                    {!isFollower ? <FaUserPlus className={classes.followIcon} /> :
                      <FaUserCheck className={classes.followIcon} />}
                  </div>

                </div>
                <div className={clsx(classes.userDetailsBox)}>
                  <Text className="mb-1" bold>
                    <Link
                      className={classes.link}
                      to={`/${twig.user.uniqueName}`}
                    >
                      {twig.user?.name}
                    </Link>
                  </Text>
                </div>
              </div>
              <div className={clsx('mt-3')}>
                <Text align="justify">{twig.description}</Text>
              </div>
              <div>
                {twig.tags?.map((tag) => (
                  <Text key={tag.id} className={classes.tag} as="span">
                    #{tag.name}
                  </Text>
                ))}
              </div>
              <hr />
              <div className={clsx(classes.reactionsBox)}>
                {isAuthenticated ? (

                  <div className={clsx(classes.reaction)}>
                    <div className={classes.reactionInner}>
                      <IconButton
                        onClick={handleAddToFavourites}
                        disabled={isFavouriting}
                        title="Favourite"
                      >
                        <FaHeart
                          className={clsx(classes.reactionIcon, {
                            [classes.favourite]: isFavourite,
                          })}
                        />
                      </IconButton>
                      <Text className={classes.reactionText} as="span">
                        {twig.favorites}
                      </Text>
                    </div>
                  </div>
                ) : null}

                {/* <div className={clsx(classes.reaction)}>
                  <div className={classes.reactionInner}>
                    <FaRetweet className={classes.reactionIcon} />
                    <Text className={classes.reactionText} as="span">
                      33
                    </Text>
                  </div>
                </div> */}

                <div className={clsx(classes.reaction)}>
                  <div className={classes.reactionInner}>
                    <FaEye className={classes.reactionIcon} />
                    <Text className={classes.reactionText} as="span">
                      {twig.views}
                    </Text>
                  </div>
                </div>

                <div className={clsx(classes.reaction)}>
                  <div className={classes.reactionInner}>
                    <IconButton title="Share" onClick={handleShare}>
                      <FaShare className={classes.reactionIcon} />
                    </IconButton>
                    {/* <Text className={classes.reactionText} as="span">
                      12
                    </Text> */}
                  </div>
                </div>
                {/* <div className={clsx(classes.reaction)}>
                  <div className={classes.reactionInner}>
                    <FaEllipsisH className={classes.reactionIcon} />
                  </div>
                </div> */}
              </div>
              <hr className="mb-0" />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const useStyles = createUseStyles({
  thumbnailBox: {
    position: 'relative',
    height: '100%',
    minHeight: '300px',
    overflow: 'hidden',
    cursor: 'pointer'
  },
  '@media (max-width: 768px)': {
    thumbnailBox: {
      minHeight: "600px"
    }
  },
  thumbnail: {
    resizeMode: 'contain',
    width: '100%',
    height: '100%',
  },
  video: {
    // position: 'absolute',
    width: '100%',
    // height: '100%',
    // margin: 'auto',
    // cursor: 'pointer',
    // left: 0,
    // right: 0,
  },
  priceBox: {},
  priceText: {
    display: 'inline-block',
    marginRight: '10px',
    fontSize: '23px',
  },
  currentPrice: {},
  oldPrice: {
    color: '#522583',
    fontSize: '16px',
  },
  sale: {
    color: '#FFFFFF !important',
    backgroundColor: '#522583',
    padding: '0 5px',
    borderRadius: '5px',
  },
  actionsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  actionBtn: {
    flex: 1,
    margin: '5px',
  },
  actionLink: {
    backgroundColor: '#7d53d9',
    padding: '10px 20px',
    textAlign: 'center',
    borderRadius: '29px',
    width: '100%',
    display: 'block',
  },
  descriptionBox: {},
  descriptionHeader: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
  },
  avatarBox: {
    width: '64px',
    height: '64px',
    overflow: 'hidden',
  },
  avatar: {
    width: '100%',
    height: '100%',
  },
  followIconBox: {
    position: "absolute",
    top: '-5px',
    width: '22px',
    cursor: 'pointer',
    height: '22px',
    backgroundColor: '#522583',
    borderRadius: '50%',
    left: '45px'
  },
  followIconBoxFollower: {
    backgroundColor: '#000'
  },
  followIcon: {
    color: 'white',
    fontSize: '15px',
    marginBottom: '7px',
    marginLeft: '4px'
  },
  userDetailsBox: {
    marginLeft: '10px',
  },
  link: {
    color: '#000',
    '&:hover': {
      color: '#000',
    },
  },
  tag: {
    display: 'inline-block',
    marginRight: '5px',
    color: '#E9C546 !important',
  },
  reactionsBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  productDetailsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },

  productDetailsSidebox: {
    overflow: 'hidden',
  },
  leftProductDetailsSidebox: {
    flex: 0.20,
  },
  rightProductDetailsSidebox: {
    flex: 0.80,
  },

  productDetailsImage: {
    borderRadius: '10px',
  },
  reaction: {
    display: 'inline-block',
    marginRight: '20px',
    color: '#b9b9b9',
  },
  reactionInner: {
    display: 'flex',
    alignItems: 'center',
  },
  reactionIcon: {
    color: '#DADADA',
  },
  reactionText: {
    marginLeft: '5px',
  },
  favourite: {
    color: 'red',
  },
  comments: {
    color: '#B9B9B9',
  },
  shares: {
    color: '#E9C546 !important',
  },
  retweets: {
    color: '#00ACEE',
  },
  more: {
    color: '#333333',
  },
  loader: {
    position: 'absolute',
    left: '43%',
    top: '150px',
  },
  videoBox: {
    textAlign: 'center',
    height: '318px',
    width: "100%",
    paddingBottom: "100%",
    overflow: "hidden"
  },

  '@media screen and (max-width : 992px)': {
    loader: {
      left: '50%',
      top: '50%',
    },
  },
});

export default Details;
